import { Injectable } from '@angular/core';

import { AnalyticsBase } from '../analytics-base';
import type { AnalyticsMode } from '../analytics.types';

export enum TagsTarget {
  Job = 'job',
  Candidate = 'candidate',
  TalentPool = 'talentPool',
}

@Injectable()
export class TagsAnalytics extends AnalyticsBase {
  public readonly namespace = 'Tags';
  public readonly requireViewContext = true;

  public trackTagAdded(target: string, mode: AnalyticsMode, candidatesCount: number = 1) {
    this.track('AddTag', { target, mode, candidatesCount });
  }

  public trackSourceAdded(mode: AnalyticsMode, candidatesCount: number = 1) {
    this.track('AddSource', { mode, candidatesCount });
  }
}
